import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=606f3f4e&scoped=true"
import script from "./UiDropdown.vue?vue&type=script&lang=js"
export * from "./UiDropdown.vue?vue&type=script&lang=js"
import style0 from "./UiDropdown.vue?vue&type=style&index=0&id=606f3f4e&prod&scoped=true&lang=css"
import style1 from "./UiDropdown.vue?vue&type=style&index=1&id=606f3f4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f3f4e",
  null
  
)

export default component.exports